import React from "react";

// reactstrap components
import { Container, Row, Col } from "reactstrap";

// Core Components

import LandingPageNavbar from "../../components/navbars/LandingPageNavbar";
import Countdown from "../../components/content/Countdown";

function LandingPageContent() {
  return (
    <>
      <LandingPageNavbar type="transparent" />
      <div className="section features-6">
        <Container>
          <Row className="align-items-center">
            <Col lg="6">
              <div className="info info-horizontal info-hover-primary">
                <div className="icon icon-shape icon-shape-info rounded-circle text-white">
                  <i className="ni ni-user-run text-info"></i>
                </div>
                <div className="description pl-4">
                  <h5 className="title">Runners</h5>
                  <p>
                    Angelo, Esmund &amp; Merlin will run 100KM on Saturday 20
                    March 2021
                  </p>
                </div>
              </div>
              <div className="info info-horizontal info-hover-primary">
                <div className="icon icon-shape icon-shape-info rounded-circle text-white">
                  <i className="ni ni-trophy text-info"></i>
                </div>
                <div className="description pl-4">
                  <h5 className="title">Challenge</h5>
                  <p>
                    We're running 100KM in aid of raising much needed funds for
                    Hannah's Place Of Safety, a Safe House for babies.
                  </p>
                </div>
              </div>
              <div className="info info-horizontal info-hover-primary">
                <div className="icon icon-shape icon-shape-info rounded-circle text-white">
                  <i className="ni ni-money-coins text-info"></i>
                </div>
                <div className="description pl-4">
                  <h5 className="title">Target</h5>
                  <p>To date we've reached R26650 of our R30000 target</p>
                </div>
              </div>
            </Col>
            <Col className="mx-md-auto" lg="6" xs="10">
              <img
                alt="..."
                className="ml-lg-5"
                src={require("assets/img/logo/Logo.png")}
                width="100%"
              ></img>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default LandingPageContent;
